module.exports = __webpack_public_path__ + "static/media/project-image-6.43b8e861.jpg";